// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__4AgKe","title":"InfoRow_title__11Ja9"};